import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors } = redesignTheme;

export const useProfileEditPhotoStyles = makeStyles(() => ({
  profilePhotoInput: {
    display: 'none',
  },
  profilePhotoLabel: {
    display: 'block',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
  },
  profilePhotoWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    overflow: 'hidden',
    '&:hover $profilePhotoOverlay': {
      opacity: 1,
    },
  },
  profilePhotoImage: {
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  profilePhotoOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 11, 51, 0.45)',
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  profilePhotoOverlayIcon: {
    fontSize: 32,
    color: colors.white,
  },
}));
